<template>
  <b-nav class="snkr-navigation">
    <b-link to="/" class="nav-logo">

      <img v-if="isFlowscore"
        src="@/assets/rebrand/nav/flowscore-white.png"
        alt="snkrhud white logo"
        class="img-logo -wht flowScoreLogo"
        style="padding: 0;"
      />
      <img v-else
        src="@/assets/rebrand/nav/snkrhud-logo-white.png"
        alt="snkrhud white logo"
        class="img-logo -wht"
      />
      <img
        src="@/assets/rebrand/nav/snkrhud-logo-black.png"
        alt="snkrhud black logo"
        class="img-logo -blk"
      />
    </b-link>
    <Push right :closeOnNavigation="true" @openMenu="preventScroll()" @closeMenu="allowScroll()" v-if="!isFlowscore">
      <ul>
        <li>
          <router-link to="/">
            Home
            <span class="link-hover">Home</span>
            <img src="@/assets/rebrand/nav/nav-link-hover.svg" class="svg-hover" alt="" />
          </router-link>
        </li>
        <li>
          <router-link to="/about-us">
            About Us
            <span class="link-hover">About Us</span>
            <img src="@/assets/rebrand/nav/nav-link-hover.svg" class="svg-hover" alt="" />
          </router-link>
        </li>
        <li>
          <router-link to="/blog">
            Blog
            <span class="link-hover">Blog</span>
            <img src="@/assets/rebrand/nav/nav-link-hover.svg" class="svg-hover" alt="" />
          </router-link>
        </li>
        <li class="minting-now">
          <a href="https://ongaia.com/snkrhud"  target="_blank">
            <img src="@/assets/rebrand/home/mint-now-gaia.png" class="nav-minting-soon" alt="" />
          </a>
        </li>
        <li class="social-links mt-4">
          <b-link href="https://discord.gg/snkrhud" target="_blank" class="social">
            <img
              src="@/assets/rebrand/nav/discord-icon-hover.png"
              alt="discord"
              class="social-hover"
            />
            <img src="@/assets/rebrand/nav/discord-icon.png" alt="discord" />
          </b-link>
          <b-link href="https://www.instagram.com/snkrhud/?hl=en" target="_blank" class="social">
            <img
              src="@/assets/rebrand/nav/hover-instagram.png"
              alt="instagram"
              class="social-hover"
            />
            <img src="@/assets/rebrand/nav/instagram1.png" alt="instagram" />
          </b-link>
        </li>
      </ul>
      <img src="@/assets/rebrand/nav/element-right.png" alt="element" class="element-right" />
      <img src="@/assets/rebrand/nav/element-left.png" alt="element" class="element-left" />
      <img src="@/assets/rebrand/nav/bottom-right.png" alt="element" class="bottom-right" />
      <img src="@/assets/rebrand/nav/upper-left.png" alt="element" class="upper-left" />
      <img src="@/assets/rebrand/nav/upper-left-1.png" alt="element" class="upper-left-1" />
      <img src="@/assets/rebrand/nav/bottom-right-1.png" alt="element" class="bottom-right-1" />
      <img src="@/assets/rebrand/nav/bottom-left-1.png" alt="element" class="bottom-left-1" />
      <img src="@/assets/rebrand/nav/upper-right-1.png" alt="element" class="upper-right-1" />
    </Push>
  </b-nav>
</template>
<script>
import { Push } from 'vue-burger-menu';

export default {
  name: 'Navigation',
  components: {
    Push,
  },
  data() {
    return {
      isFlowscore: false,
    };
  },
  methods: {
    preventScroll() {
      const element = document.querySelector('#app');
      element.classList.add('pos-fix');
      // document.querySelector("#app").style.position = "fixed";
    },
    allowScroll() {
      setTimeout(() => {
        // document.querySelector("#app").style.position = null;
        const element = document.querySelector('#app');
        element.classList.remove('pos-fix');
      }, 500);
    },
  },
};
</script>
<style lang="scss">
@import "../assets/styles/navigation.scss";
.pos-fix {
  position: fixed !important;
  padding-right: 1.1vw;
  @media not all and (min-resolution: 0.001dpcm) {
    padding-right: 0;
  }
  @media (max-width:769px) {
    padding-right: 0;
  }
}
</style>
